import { PlaygroundSeedMessage } from "../types";

// An edit makes the message the client's own: the replacement content,
// function call, kv value, or kv key goes in, and the origin provenance
// comes off — its absence is what marks an edited message.
export const applyItemEdit = (
  message: PlaygroundSeedMessage,
  edit: Partial<PlaygroundSeedMessage>
): PlaygroundSeedMessage => {
  const edited: Record<string, unknown> = { ...message, ...edit };
  delete edited.origin_session_id;
  delete edited.origin_moment_id;
  return edited as PlaygroundSeedMessage;
};
